export default __webpack_public_path__ + "static/media/sm_castrol1.fd9a4d8f.jpg";